import "./App.scss";
import MotionSystem from "./components/animations/MotionSystem";
import SmoothScrollProvider from "./components/animations/SmoothScrollProvider";
import PageLoader from "./components/layout/PageLoader";
import Navigation from "./components/navigation/Navigation";
import ProjectShowcase from "./components/projects/ProjectShowcase";
import ContactSection from "./components/sections/ContactSection";
import EducationSection from "./components/sections/EducationSection";
import ExperienceSection from "./components/sections/ExperienceSection";
import HeroSection from "./components/sections/HeroSection";
import IntroductionSection from "./components/sections/IntroductionSection";
import SkillsSection from "./components/sections/SkillsSection";
import StatementSection from "./components/sections/StatementSection";
import CustomCursor from "./components/ui/CustomCursor";
import ScrollProgress from "./components/ui/ScrollProgress";
import { enum_data } from "./enum_data";

function App() {
  return (
    <SmoothScrollProvider>
      <PageLoader />
      <Navigation />
      <ScrollProgress />
      <CustomCursor />
      <MotionSystem />

      <main>
        <HeroSection
          about={enum_data.about}
          profileImage={enum_data.profile_img}
          socialLinks={enum_data.social_links}
        />
        <IntroductionSection
          services={enum_data.what_i_do}
          stats={enum_data.experience}
        />
        <ExperienceSection experiences={enum_data.work_experience} />
        <ProjectShowcase projects={enum_data.projects} />
        <SkillsSection skills={enum_data.skills} />
        <EducationSection
          education={enum_data.education}
          languages={enum_data.language}
        />
        <StatementSection />
        <ContactSection
          contacts={enum_data.contact_information}
          socialLinks={enum_data.social_links}
        />
      </main>
    </SmoothScrollProvider>
  );
}

export default App;
